import { useEffect } from 'react';

import api from 'api';

export default function useDetailLoad(jobID, jobStore, uiStore, company, onError) {
  const job = jobStore.items.get(jobID);
  useEffect(() => {
    if (uiStore.preview) return;

    if (job) {
      job.load();
    } else if (jobStore.state === 'loaded') {
      api.jobs.loadDetail(company, jobID).then((res) => {
        if (!res.error && res.data.companyName === company) {
          jobStore.addOrUpdate(res.data);
        } else {
          onError();
        }
      });
    }
  }, [job, jobStore.state, jobID, jobStore, onError, company, uiStore.preview]);
}
